export class EditServiceSubscriptionModel {
    Id: number
    Description: string;
    FrequencyId?: number;
    ScheduleId?: number;
    IsAutoApproved: boolean;

    constructor(
        Id: number,
        Description: string,
        FrequencyId: number,
        ScheduleId: number,
        IsAutoApproved: boolean,
    ){
        this.Id = Id;
        this.Description = Description;
        this.FrequencyId = FrequencyId;
        this.ScheduleId = ScheduleId;
        this.IsAutoApproved = IsAutoApproved;
    }
}


// WEBPACK FOOTER //
// ./src/app/developer/components/service-subscription-editor/models/editServiceSubscriptionModel.ts